<template>
  <div class="masker">
    <transition name="actionSheet-fade" appear @after-leave="leave">
      <div class="actionSheet" style="height:200px" v-show="show">
        <div class="title" :style="title.style || ''">
			<div class="close" style="right: 0;" @click="clickItem('cancel')"></div>
			<p style="line-height:130px">{{title.txt ||title}}</p>
		</div>
		<div class="btnline">
			<button class="btntrue" @click="closewindow">确定</button>
			<button class="btncancle" style="margin-left:30px" @click="show = false">取消</button>
		</div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'confirm',
  data() {
    return {
		show:true,
		select:"满意",
		title: {
			txt: '您确定要结束对话并关闭当前窗口吗？',
			style:{
				'position':'relative',
			}
      },
      clickEvent: () => {}
    }
  },
  methods: {
    clickItem(item) {
      this.clickEvent && this.clickEvent(item);
      this.show = false;
    },
    leave() {
      document.body.removeChild(this.$el);
	},
	closewindow() {
		this.show = false
		Bus.$emit("triggerFeedActionsheet", ()=>{
			setTimeout(() => {
				window.opener=null;
				window.open('','_self');
				window.close();
			},300)
		}, true)
	}
  }
}
</script>
<style scoped>
	.btnline{
		position: relative;
	}
	.btnline .btntrue {
		color: #ffffff;
		font-size: 14px;
		padding: 6px 20px 6px 20px;
		background: #4A90E2;
		border:none;
		cursor: pointer;
	}

	.btnline .btntrue:hover {
		background: #2980b9;
		color: #ffffff;
	}
	.btnline .btncancle{
		color: #666666;
		font-size: 14px;
		padding: 6px 20px 6px 20px;
		background: #F5F5F5;
		border:none;
		cursor: pointer;
	}
	.btnline .btncancle:hover {
		background: #d4d6d7;
		color: #ffffff;
	}
</style>



// WEBPACK FOOTER //
// src/components/dialog/Confirm.vue